import React from 'react';
import { getErrorMessage } from './getErrorMessage';

export const createUseContext =
    <T = any>(context: React.Context<T>) =>
    () => {
        const contextValue = React.useContext(context);

        if (!contextValue) {
            throw new Error(getErrorMessage({ displayName: context?.displayName }));
        }

        return contextValue;
    };
